// extracted by mini-css-extract-plugin
module.exports = {"container":"Building_container__25_xd","errorMessage":"Building_errorMessage__3nXo1","head":"Building_head__3_RnC","outerTemplate":"Building_outerTemplate__9Wk0o"};